import React from 'react'
import styles from './SplitMain.module.scss'

interface SplitMainProps {
  children: React.ReactNode
  className?: never
}

export const SplitMain: React.FC<SplitMainProps> = ({ children }) => (
  <div className={styles.main}>{children}</div>
)
